import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ListaService } from '../../../_services/lista.service';
import { ConfirmationService } from 'primeng/api';
import { NavService } from '../../../_services/_nav.service';
import { AutenticacionService } from '../../../_services/autenticacion.service';
import { Table } from 'primeng/table';
import { Campania } from '../../../_models/campania';
import { Funcionalidad } from '../../../_models/funcionalidad';
import { CampaniaDescuentoMora } from '../../../_models/campania-descuento-mora';
import { CampaniaDescuentoMoraService } from '../../../_services/campania-descuento-mora.service';
import { Location } from '@angular/common';

@Component( {
  selector: 'app-campania-descuento-mora-detalle',
  templateUrl: 'campania-descuento-mora-detalle.component.html'
} )

export class CampaniaDescuentoMoraDetalleComponent implements OnInit {

  @Input() campania: Campania;
  formulario: FormGroup;

  /** Listas */
  lisCampaniasDescuentoMora: CampaniaDescuentoMora[] = [];

  columnas: any[] = [];
  carInformacionInicial = true;
  carTabla = true;
  @ViewChild('dt') tabla: Table;
  menu: Funcionalidad = new Funcionalidad();


  constructor(
    private conServicio: ConfirmationService,
    private fb: FormBuilder,
    private serCampaniaDescuentoMora: CampaniaDescuentoMoraService,
    private route: ActivatedRoute,
    private lisServicio: ListaService,
    private navServicio: NavService,
    private router: Router,
    private autServicio: AutenticacionService,
    private location: Location
  ) {
  }

  ngOnInit() {
    if ( this.campania && (this.campania.idCampania !== '' && this.campania.idCampania !== null && this.campania.idCampania !== undefined) ) {
      /** Se carga las campanias */
      this.serCampaniaDescuentoMora.obtenerPorCampania( this.campania.idCampania ).subscribe( registros => {
        this.lisCampaniasDescuentoMora = registros.filter( x => x.indicadorHabilitado );
        const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/campania' );
        if ( mn ) {
          this.menu = mn;
        }

        this.columnas = [
          { field: 'diaMinMora', header: this.navServicio.buscarMensaje( 'CAMPANIADCTODESTINO.LBL_DIAMINMORA' ), sort: true },
          { field: 'diaMaxMora', header: this.navServicio.buscarMensaje( 'CAMPANIADCTODESTINO.LBL_DIAMAXMORA' ), sort: true },
          { field: 'descuentoTasa', header: this.navServicio.buscarMensaje( 'CAMPANIADCTODESTINO.LBL_DESCUENTOTASA' ), sort: true }
        ];
        this.carTabla = false;
        this.carInformacionInicial = false;
      } );
    }
  }

  regresar() {
    this.location.back();
  }


}
